import { BrowserRouter } from 'react-router-dom';
import { StoreProvider } from 'easy-peasy';

import Layout from 'components/Layout';
import Routes from './Routes';
import { AuthProvider } from 'context/AuthContext';
import { store } from 'store';

const App = () => {
  return (
    <AuthProvider>
      <StoreProvider store={store}>
        <BrowserRouter>
          <Layout>
            <Routes />
          </Layout>
        </BrowserRouter>
      </StoreProvider>
    </AuthProvider>
  );
};

export default App;
